import Model, { attr, belongsTo } from '@ember-data/model';
import { cached } from '@glimmer/tracking';
import { type Registry as Services, service } from '@ember/service';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export enum ScheduledMessageStatus {
  sent = 'sent',
  tooLate = 'too_late',
  failed = 'failed',
  pending = 'pending',
}

export default class ScheduledMessageModel extends Model {
  @service intl!: Services['intl'];

  @attr('boolean') enabled!: boolean;
  @attr('string') lastError!: string;
  @attr('date') scheduledFor!: Date;
  @attr('date') sentAt!: Date;
  @attr('string') status!: ScheduledMessageStatus;

  @belongsTo('booking', { async: false, inverse: 'scheduledMessages' })
  booking!: ModelRegistry['booking'];

  @belongsTo('automated-message-rule', {
    async: false,
    inverse: null,
  })
  automatedMessageRule!: ModelRegistry['automated-message-rule'];

  @cached
  get sendingStopped(): boolean {
    return [
      ScheduledMessageStatus.sent,
      ScheduledMessageStatus.tooLate,
      ScheduledMessageStatus.failed,
    ].includes(this.status);
  }

  @cached
  get prettyStatus(): string {
    let translationKey = 'action_bookings_logs.scheduled_message_statuses.';

    translationKey += this.enabled === false ? 'disabled' : this.status;

    return this.intl.t(translationKey);
  }
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'scheduled-message': ScheduledMessageModel;
  }
}
